export default __webpack_public_path__ + "fe2fece79f0abd8c304457be4a0f47b9.svg";